module.exports = __webpack_public_path__ + "static/media/redPoppedBalloon.0282877a.svg";